<template>
  <div v-loading="loading">
    <vxe-toolbar id="boxMakingArea">
      <template v-slot:buttons>
        <el-button @click="init">重置</el-button>
        <el-button @click="funcSave">提交</el-button>
      </template>
    </vxe-toolbar>
    <div class="main">
      <ul class="name">
        <li>车牌</li>
        <li>车牌颜色</li>
        <li>车辆类型代码</li>
        <li>所有人</li>
        <li>使用性质</li>
        <li>vin</li>
        <li>行驶证发证机关</li>
        <li>行驶证注册日期</li>
        <li>行驶证发证日期</li>
        <li>车辆能源类型</li>
        <li>核定载质量</li>
        <li>总质量</li>
        <li>道路运输证号</li>
        <li>车轴数</li>
        <li>道路运输证字</li>
        <li>是否挂车</li>
        <li>挂车车牌号</li>
        <li>挂车颜色代码</li>
        <li>挂车载质量</li>
        <li>挂车总质量</li>
      </ul>
      <ul v-if="JSON.stringify(form) != '{}'" class="driver">
        <li>{{ form.licenseNumber }}</li>
        <li>{{ funcTranslate(form.vehicleLicenseColor) }}</li>
        <li>{{ funcClassify(form.classificationCode) }}</li>
        <li>{{ form.realOwner }}</li>
        <li>{{ form.useCharacter }}</li>
        <li>{{ form.vin }}</li>
        <li>{{ form.issuingOrganizations }}</li>
        <li>{{ form.registerDate }}</li>
        <li>{{ form.issueDate }}</li>
        <li>{{ funcEnergy(form.vehicleEnergyType) }}</li>
        <li>{{ form.loadWeight }}</li>
        <li>{{ form.totalWeight }}</li>
        <li>{{ form.roadTransportCertificateNumber }}</li>
        <li>{{ form.axlenum }}</li>
        <li>{{ form.roadTransportCertificateWord }}</li>
        <li>{{ form.isHasTrailer == 1?'是':'否' }}</li>
        <li>{{ form.trailerNum }}</li>
        <li>{{ funcTranslate(form.trailerLicenseColor) }}</li>
        <li>{{ form.trailerLoadWeight }}</li>
        <li>{{ form.trailerTotalWeight }}</li>
      </ul>
      <template v-if="data && data.length > 0">
        <ul v-for="(item, index) in data" :key="index" class="object" @click="changeValue($event)">
          <li data-attr="licenseNumber">{{ item.licenseNumber }}</li>
          <li data-attr="vehicleLicenseColor" :data-define="item.vehicleLicenseColor">
            {{ funcTranslate(item.vehicleLicenseColor) }}</li>
          <li data-attr="classificationCode" :data-define="item.classificationCode">
            {{ funcClassify(item.classificationCode) }}</li>
          <li data-attr="realOwner">{{ item.realOwner }}</li>
          <li data-attr="useCharacter">{{ item.useCharacter }}</li>
          <li data-attr="vin">{{ item.vin }}</li>
          <li data-attr="issuingOrganizations">{{ item.issuingOrganizations }}</li>
          <li data-attr="registerDate">{{ item.registerDate }}</li>
          <li data-attr="issueDate">{{ item.issueDate }}</li>
          <li data-attr="vehicleEnergyType" :data-define="item.vehicleEnergyType">{{ funcEnergy(item.vehicleEnergyType) }}
          </li>
          <li data-attr="loadWeight">{{ item.loadWeight }}</li>
          <li data-attr="totalWeight">{{ item.totalWeight }}</li>
          <li data-attr="roadTransportCertificateNumber">{{ item.roadTransportCertificateNumber }}</li>
          <li data-attr="axlenum">{{ item.axlenum }}</li>
          <li data-attr="roadTransportCertificateWord">{{ item.roadTransportCertificateWord }}</li>
          <li data-attr="isHasTrailer" :data-define="item.isHasTrailer">{{ item.isHasTrailer == 1?'是':'否' }}</li>
          <li data-attr="trailerNum">{{ item.trailerNum }}</li>
          <li data-attr="trailerLicenseColor" :data-define="item.trailerLicenseColor">{{ funcTranslate(item.trailerLicenseColor) }}</li>
          <li data-attr="trailerLoadWeight">{{ item.trailerLoadWeight }}</li>
          <li data-attr="trailerTotalWeight">{{ item.trailerTotalWeight }}</li>
        </ul>
      </template>

    </div>

  </div>
</template>
<script>
	import {
		rainbowVehicleSave,
		vehicleInfor
	} from "@/api/driver";
	export default {
		name: "DriverDetail",
		props: {
			parentData: {
				type: Object,
				default () {
					return {
						driverType: ''
					};
				},
			},
		},
		data() {
			return {
				form: {},
				emptyForm: {},
				data: [],
				vehicleCode: '',
				codes: '',
				loading: false
			}
		},
		methods: {
			funcTranslate(value) {
				let item = this.parentData.vehicleLicenseColorList.find(item => item.code == value)
				return item ? item.name : ''
			},
			funcEnergy(value) {
				let item = this.parentData.vehicleEnergyTypeList.find(item => item.code == value)
				return item ? item.name : ''
			},
			funcClassify(value){
				let item = this.parentData.vehicleClassificationList.find(item => item.code == value)
				return item ? item.name : ''
			},
			init() {
				this.form = JSON.parse(JSON.stringify(this.emptyForm))
			},
			funcInit() {
				this.$set(this, 'form', {})
				this.$set(this, 'emptyForm', {})
				this.$set(this, 'data', [])
				this.$set(this, 'vehicleCode', '')
			},
			changeValue(e) {
				if (e.target.dataset.attr && e.target.dataset.define) {
					this.$set(this.form, `${e.target.dataset.attr}`, e.target.dataset.define)
				}else{
					if (e.target.dataset.attr && e.target.innerText) {
						this.$set(this.form, `${e.target.dataset.attr}`, e.target.innerText)
					}
				}
			},
			getVehicle(code) {
				this.loading = true
				vehicleInfor({code:code}).then((response) => {
					this.form = response.data.vehicle;
					this.data = response.data.vehicleRainbows
					this.emptyForm = JSON.parse(JSON.stringify(this.form))
					this.loading = false
				});
			},
			funcSave() {
				this.$confirm('确认提交吗？')
					.then(_ => {
						this.form.codes = this.data.map(item => item.code).join(',');
						this.loading = true;
						rainbowVehicleSave(this.form).then(response => {
							this.$message({
								message: response.msg,
								type: 'success'
							});
							this.loading = false;
							this.$emit('fatherMethods')
						}).catch( err => {
							this.loading = false
						})
					})
					.catch(_ => {});
			},
		}
	};
</script>
<style scoped lang="scss">
	ul,
	li {
		padding: 0;
		margin: 0;
		list-style: none
	}

	.main {
		width: 100%;
		overflow-x: auto;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		border: 1px solid #ebeef5;

		ul {
			min-width: 200px;

			li {
				height: 54px;
				line-height: 54px;
				min-width: 0;
				border-bottom: 1px solid #ebeef5;
				box-sizing: border-box;
				text-overflow: ellipsis;
				vertical-align: middle;
				position: relative;
				text-align: center;
			}

			li:last-child {
				border-bottom: none;
			}
		}

		ul {
			border-right: 1px solid #ebeef5;
		}

		.object li {
			cursor: pointer;
		}

		.name {
			position: sticky;
			left: 0;
			background-color: #f8f8f9;
			z-index: 9;
		}

		.driver {
			position: sticky;
			left: 200px;
			background-color: #f8f8f9;
			z-index: 9
		}
	}
</style>
